import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=55c7dce9&scoped=true"
import script from "./pure.vue?vue&type=script&setup=true&lang=js"
export * from "./pure.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pure.vue?vue&type=style&index=0&id=55c7dce9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7dce9",
  null
  
)

export default component.exports